var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_STORE_REQUEST, SAVE_STORE_REQUEST, UPDATE_STORE_REQUEST, fetchStoreFailure, fetchStoreSuccess, saveStoreDataFailure, saveStoreDataSuccess, updateStoreDataFailure, updateStoreDataSuccess } from '../../actions';
import API from '../../../utils/API';
const onFetchStore = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            API.get(`onbd/channel/list`)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
const onSaveStore = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            API.post(`/onbd/channel`, action.payload)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
const onUpdateStore = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = action.payload;
            API.put(`/onbd/channel/${data.id}/${data.status}`, action.payload)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchStoreWorker(action) {
    try {
        const data = yield call(onFetchStore, action);
        yield put(fetchStoreSuccess(data));
    }
    catch (error) {
        yield put(fetchStoreFailure(error));
    }
}
function* saveStoreWorker(action) {
    try {
        const data = yield call(onSaveStore, action);
        yield put(saveStoreDataSuccess(data));
    }
    catch (error) {
        yield put(saveStoreDataFailure(error));
    }
}
function* updateStoreWorker(action) {
    try {
        const data = yield call(onUpdateStore, action);
        yield put(updateStoreDataSuccess(data));
    }
    catch (error) {
        yield put(updateStoreDataFailure(error));
    }
}
export function* watchStoreData() {
    yield takeLatest(FETCH_STORE_REQUEST, fetchStoreWorker);
    yield takeLatest(SAVE_STORE_REQUEST, saveStoreWorker);
    yield takeLatest(UPDATE_STORE_REQUEST, updateStoreWorker);
}
